import '../common/common';
import { shopSdk } from '../graphql/shopClient';

$(function() {
    resetState();
    const input = $('#donate-amt');
    const pattern = /^\d+(\.\d{0,2})?(\.+)?/;
    input.on('keyup', (e) => {
        const val = input.val();
        const validAndInvalid = pattern.exec(val as string);
        if (validAndInvalid && validAndInvalid[1]) {
            input.val(validAndInvalid[0]);
        }
    });
    input.on('input', setDonationAmount);
    input.on('blur', () => {
        const val = input.val();
        if (/\./.test(val as string)) {
            input.val(val + '00');
        } else {
            input.val(val + '.00');
        }
        const validVal = pattern.exec(input.val() as string);
        if (validVal) {
            input.val(validVal[0]);
        } else {
            input.val('');
        }
    });
    $('input[name="option-brand"]').on('change', (e) => {
        $('#donate-amt').prop('disabled', false);
        $('#donate-btn').prop('disabled', false);
        variantChanged();
    });
    $(document).on('donation-added', () => {
        resetState();
        $('#donate-thanks').show();
    });
});

function variantChanged() {
    let selectedValue = $('input[name="option-brand"]:checked').val();
    if (!selectedValue) { return; }
    selectedValue = (''+selectedValue).toLowerCase(); // because jsonify | safeJS always creates window.donateVariants with lowercase keys
    const btn = document.querySelector('#donate-btn') as HTMLButtonElement;
    const variant = (window.donateVariants || {})[selectedValue];
    btn.dataset.itemId = variant?.id || '';
    btn.dataset.itemSku = variant?.sku || '';
    btn.dataset.itemName = variant?.name || '';
    return variant;
}
function setDonationAmount() {
    const input = document.querySelector('#donate-amt') as HTMLInputElement;
    let val = Math.floor(Number(input.value) * 100); // convert "3.25" to 325
    if (isNaN(val) || val <= 0) {
        val = 0;
    }
    const btn = document.querySelector('#donate-btn') as HTMLButtonElement;
    btn.dataset.amount = val.toString();
}

function resetState() {
    $('input[name="option-brand"]').prop('checked', false);
    $('#donate-amt').val('');
    $('#donate-amt').prop('disabled', true);
    $('#donate-btn').prop('disabled', true);
    setDonationAmount();
    variantChanged();
}
